import clsx from "clsx";

export const Group = ({ data, onSelect, onHover, outHover, bigSize }) => {
	return (
		<div className="swiper-slide slide-19">
			<div
				className={clsx({
					"slideContainer-28": true,
					half: !bigSize,
					selected: data.selected,
				})}
				onMouseEnter={onHover}
				onMouseLeave={outHover}
				onClick={() => {
					onSelect(data.id);
				}}
			>
				<div className="bgWrap">
					<svg
						width="160"
						height="157"
						viewBox="0 0 160 157"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M24.1851 10.892C36.3443 0.0172701 68.5577 -0.148982 83.7761 0.0341487C98.9937 0.218123 124.421 7.70031 134.451 21.4469C144.32 34.9707 157.858 57.9287 159.119 75.7801C160.042 88.8533 161.505 106.808 155.843 118.276C149.795 130.526 133.626 145.593 124.062 151.863C105.247 164.195 45.2734 152.271 27.4845 137.728C-7.00767 109.528 -10.0686 41.5288 24.1851 10.892Z"
							fill={data.bgColor}
						/>
					</svg>
					<svg
						className={clsx({ circle: true, circleAppear: data.selected })}
						width="229"
						height="234"
						viewBox="0 0 229 234"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<mask id="path-1-inside-1" fill="white">
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M210.465 52.4172C222.938 70.0385 218.594 112.726 216.2 132.856C213.806 152.985 200.44 185.618 181.077 196.984C162.028 208.168 130.146 222.896 106.667 222.075C89.4726 221.473 65.8305 220.906 51.6635 211.807C36.5301 202.088 19.1527 178.571 12.3235 165.029C-1.10931 138.39 22.9448 60.6217 44.4458 39.0905C86.1363 -2.65761 175.326 2.77587 210.465 52.4172Z"
							></path>
						</mask>
						<path
							d="M216.2 132.856L219.179 133.211L219.179 133.211L216.2 132.856ZM181.077 196.984L179.559 194.397L179.558 194.397L181.077 196.984ZM106.667 222.075L106.562 225.073L106.562 225.073L106.667 222.075ZM51.6635 211.807L50.0423 214.332L50.0423 214.332L51.6635 211.807ZM12.3235 165.029L9.64483 166.38L9.64488 166.38L12.3235 165.029ZM44.4458 39.0905L42.323 36.9706L42.323 36.9707L44.4458 39.0905ZM208.016 54.1504C210.785 58.0624 212.743 63.5633 214.014 70.1567C215.277 76.7147 215.822 84.1391 215.908 91.7298C216.079 106.914 214.416 122.455 213.221 132.502L219.179 133.211C220.378 123.127 222.084 107.26 221.907 91.662C221.819 83.8619 221.26 76.0523 219.905 69.0213C218.557 62.0256 216.381 55.5826 212.913 50.6839L208.016 54.1504ZM213.221 132.502C212.07 142.18 208.246 155.037 202.32 166.862C196.365 178.745 188.51 189.142 179.559 194.397L182.596 199.571C193.008 193.459 201.517 181.857 207.684 169.55C213.88 157.186 217.936 143.662 219.179 133.211L213.221 132.502ZM179.558 194.397C170.151 199.92 157.575 206.317 144.481 211.222C131.332 216.148 117.928 219.467 106.772 219.077L106.562 225.073C118.884 225.504 133.161 221.87 146.586 216.841C160.065 211.791 172.955 205.232 182.596 199.571L179.558 194.397ZM106.772 219.077C98.1315 218.774 88.0879 218.485 78.4394 217.155C68.75 215.821 59.8164 213.478 53.2847 209.283L50.0423 214.332C57.6777 219.235 67.6486 221.726 77.6206 223.099C87.6334 224.479 98.0079 224.773 106.562 225.073L106.772 219.077ZM53.2848 209.283C46.1169 204.679 38.2272 196.659 31.2143 187.968C24.2239 179.304 18.2998 170.217 15.0022 163.678L9.64488 166.38C13.1765 173.383 19.3556 182.825 26.5447 191.735C33.7111 200.617 42.0768 209.216 50.0423 214.332L53.2848 209.283ZM15.0023 163.678C12.0094 157.743 10.954 148.543 11.6464 137.325C12.3324 126.212 14.7046 113.532 18.1765 100.942C21.6465 88.3587 26.1918 75.9503 31.1797 65.3866C36.1953 54.7646 41.5545 46.2315 46.5686 41.2103L42.323 36.9707C36.5866 42.7151 30.8762 51.9772 25.7542 62.8248C20.6046 73.7307 15.9444 86.4663 12.3924 99.3466C8.84233 112.22 6.37587 125.322 5.65778 136.956C4.94612 148.485 5.92122 158.995 9.64483 166.38L15.0023 163.678ZM46.5685 41.2104C66.6353 21.1159 98.4041 12.1748 129.692 14.4747C160.973 16.7742 191.104 30.259 208.016 54.1504L212.913 50.6839C194.686 24.9341 162.653 10.8815 130.132 8.49088C97.6179 6.1008 63.9467 15.317 42.323 36.9706L46.5685 41.2104Z"
							fill={data.circleColor}
							mask="url(#path-1-inside-1)"
						></path>
					</svg>
				</div>
				<div className="dataSlide-24">
					<span className="ageGroupName-26">
						{data.title || "Default Title"}
					</span>
					<p className="ageGroup-27">{data.ageGroup || "Default ageGroup"}</p>
				</div>
			</div>
		</div>
	);
};
